import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "top-box"
};
var _hoisted_2 = {
  class: "contain-box"
};
var _hoisted_3 = {
  class: "title"
};
var _hoisted_4 = {
  class: "tips"
};
var _hoisted_5 = {
  style: {
    "margin-right": "20px"
  }
};
var _hoisted_6 = ["innerHTML"];
import { getArticleDetail } from '@/api/topic';
import { useRoute } from 'vue-router';
import { ref } from 'vue';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var route = useRoute();
    var dataObj = ref({});
    var id = route.query.id;
    var loadArticleDetail = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getArticleDetail(id);
            case 1:
              res = _context.v;
              if (res.data.code === 0) dataObj.value = res.data.data;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function loadArticleDetail() {
        return _ref.apply(this, arguments);
      };
    }();
    loadArticleDetail();
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, _toDisplayString(dataObj.value.title), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(dataObj.value.createTime), 1), _createElementVNode("span", null, _toDisplayString(dataObj.value.author), 1)]), _createElementVNode("div", {
        innerHTML: dataObj.value.context,
        class: "content-box"
      }, null, 8, _hoisted_6)])]);
    };
  }
};